import React from 'react'
import { Tabs, Card } from 'antd';
import { Loader } from '../Loader/Loader'
import web1 from '../Assets/web1.png'
import web2 from '../Assets/web2.png'

const { Meta } = Card;
const Webinar = ({ loader, setCollapsed }) => {
    const items = [
        {
            key: '1',
            label: 'NEW',
            children: <div className=''>
                <Card
                    hoverable
                    style={{ width: "100%", marginTop: "0px" }}
                    cover={
                        <img
                            draggable={false}
                            alt="example"
                            src={web1}
                        />
                    }
                    className='web-card'
                >
                    <Meta title="TEST" description="9 Sep 2025,20:00 (UTC+6)" className='meta-desc' />
                </Card>
                <Card
                    hoverable
                    style={{ width: "100%", marginTop: "25px" }}
                    cover={
                        <img
                            draggable={false}
                            alt="example"
                            src={web2}
                        />
                    }
                    className='web-card'
                >
                    <Meta title="Coming soon!" description="30 Sep 2025,18:10 (UTC+6)" className='meta-desc' />
                </Card>

            </div>,
        },
        {
            key: '2',
            label: 'HISTORY',
            children: <div className='no-promo'>
                Coming Soon
            </div>,
        },

    ];

    const onChange = key => {
        console.log(key);
    };

    return (
        <>
            {loader ?
                <Loader /> :
                <>
                    <div className='display-5 p-20 trad-pos'>
                        <div className='side-title'>
                            Webinar
                        </div>
                        <div className='cursor' onClick={() => setCollapsed(true)} id='cs'>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.0215 1.70605C13.6494 1.07837 14.6661 1.07823 15.2939 1.70605C15.9218 2.33389 15.9208 3.34966 15.293 3.97754L15.2939 3.97852L10.7725 8.5L15.2939 13.0215C15.9217 13.6494 15.9209 14.6652 15.293 15.293C14.9799 15.6061 14.5678 15.7646 14.1572 15.7646C13.7469 15.7646 13.3345 15.6068 13.0215 15.2939L8.5 10.7725L3.97852 15.2939C3.66549 15.6068 3.25314 15.7646 2.84277 15.7646C2.43255 15.7646 2.02021 15.6063 1.70703 15.293C1.07904 14.6652 1.07825 13.6494 1.70605 13.0215L6.22754 8.5L1.70605 3.97852C1.0782 3.35062 1.07812 2.3339 1.70605 1.70605C2.33401 1.0781 3.35056 1.07844 3.97852 1.70605L8.5 6.22754L13.0215 1.70605Z" fill="#82858E" stroke="#82858E" stroke-width="1.5294" />
                            </svg>
                        </div>
                    </div>
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='promo-tab' style={{ height: "100%" }} />;
                </>}
        </>
    )
}

export default Webinar